export default __webpack_public_path__ + "static/awarepath_small-image_3-1--03f1c3836d082e287a9b830a360cb4ff.webp";